import React from 'react';
import { ROLE, ROLEALL, PERMISSION } from "../../services/actions";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import RFG from '../../libs/inputs/RFG';
import { BsTrashFill, BsKeyFill, BsCheckCircleFill, BsDashCircleFill, BsShieldLockFill, BsShieldCheck, BsArrowLeft, BsSearch, BsPersonBadgeFill, BsPlusLg } from "react-icons/bs";
import Swal from 'sweetalert2';
import { Container, Button, Box, Grid, Typography, Chip, Stack, IconButton, Card, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@mui/material";
import { FormHeroHeader, FormSectionCard, labelStyle } from "../extra/FormLayout";

export default function Role() {
    let dispatch = useDispatch()
    const navigate = useNavigate()
    let roleState = useSelector((state) => state?.roleState)
    let roleallState = useSelector((state) => state?.roleallState)
    const [view, setView] = React.useState(1)
    const [selectedRole, setSelectedRole] = React.useState()
    const [openPemissionDlg, setOpenPemissionDlg] = React.useState([])
    const [roleSearch, setRoleSearch] = React.useState("")
    const [permSearch, setPermSearch] = React.useState("")

    const { handleSubmit, control, reset, watch } = useForm({ defaultValues: {}, mode: "all" })

    React.useEffect(() => {
        dispatch({ type: `${ROLEALL}_GET`, payload: 0 });
    }, [])

    React.useEffect(() => {
        dispatch({ type: `${ROLEALL}_GET`, payload: 0 });
    }, [roleState?.data])

    const confirm2 = (event, data) => {
        Swal.fire({
            title: "Delete Role?",
            text: `Are you sure you want to permanently delete the '${data?.name}' role?`,
            icon: "warning",
            showDenyButton: true,
            confirmButtonColor: "#64748b",
            denyButtonColor: "#ef4444",
            confirmButtonText: "Cancel",
            denyButtonText: `Delete Role`
        }).then((result) => {
            if (result.isDenied) {
                onDelete(data)
            }
        })
    };

    const onSubmit = (data) => {
        let action = data.id ? `${ROLE}_PATCH` : `${ROLE}_POST`
        dispatch({
            type: action, payload: data, callback: (resp) => {
                reset({ name: "", id: "" });
                dispatch({ type: `${ROLEALL}_GET`, payload: 0 });
                Swal.fire({
                    icon: 'success',
                    title: 'Role Saved',
                    text: `Role '${data.name}' has been successfully created.`,
                    timer: 1800,
                    showConfirmButton: false
                });
            }
        });
    }

    const onDelete = (data) => {
        let action = data.id ? `${ROLE}_DELETE` : `${ROLE}_POST`
        dispatch({
            type: action, payload: data.id, callback: (resp) => {
                dispatch({ type: `${ROLEALL}_GET`, payload: 0 });
                Swal.fire({
                    icon: 'success',
                    title: 'Role Deleted',
                    text: `Role '${data.name}' was removed.`,
                    timer: 1500,
                    showConfirmButton: false
                });
            }
        });
    }

    const formatData = (role) => {
        if (!role?.name) return null
        setView(2)
        setSelectedRole(role.name)
        setPermSearch("")
        let assigned = role._assigned || {}
        let all = role?._permission ? Object.keys(role?._permission).map((key) => {
            let access = { role: role.name, value: key, name: key, custom_perms: [] }
            for (let _access of role?._permission[key]) {
                let per = _access.codename.split("_")[0]
                let isStandard = false;
                if (['add', 'change', 'delete', 'view'].includes(per) && !access[per]) {
                    access[per] = _access.codename
                    access[`${per}_assigned`] = false
                    if (assigned[key]) {
                        for (let _assigned of assigned[key]) {
                            if (_access.codename == _assigned.codename) {
                                access[`${per}_assigned`] = true
                                break
                            }
                        }
                    }
                    isStandard = true;
                }
                
                if (!isStandard) {
                    let is_assigned = false;
                    if (assigned[key]) {
                        for (let _assigned of assigned[key]) {
                            if (_access.codename == _assigned.codename) {
                                is_assigned = true;
                                break;
                            }
                        }
                    }
                    access.custom_perms.push({
                        codename: _access.codename,
                        name: _access.name,
                        assigned: is_assigned
                    });
                }
            }
            return access
        }) : []

        setOpenPemissionDlg(all)
        return all
    }

    const addPermission = (role, permission, action) => {
        if (!permission) return;
        let data = {
            id: 0,
            name: role,
            permissions: [permission],
            action: action ? "add" : "remove"
        }
        dispatch({
            type: `${ROLE}_PATCH`, payload: data, callback: (resp) => {
                formatData(resp)
            }
        });
    }

    const filteredRoles = (roleallState?.data?.results || []).filter(r =>
        r?.name?.toLowerCase().includes(roleSearch.toLowerCase())
    );

    const filteredPerms = openPemissionDlg.filter(p =>
        p?.name?.toLowerCase().includes(permSearch.toLowerCase())
    );

    return (
        <Box sx={{ py: 3, px: { xs: 1.5, md: 3 }, maxWidth: '1600px', width: '100%', mx: 'auto' }}>
            {view === 2 ? (
                <Box>
                    <FormHeroHeader
                        icon={<BsShieldCheck size={26} />}
                        title={`Access Control Matrix: ${selectedRole}`}
                        subtitle={`Configure granular Add, View, Change, and Delete permissions across system modules for '${selectedRole}'.`}
                        badgeText="Security Tier"
                    />

                    <FormSectionCard
                        icon={<BsKeyFill size={20} />}
                        title="Module Permissions"
                        subtitle="Toggle individual access rights for this role. Changes take effect immediately."
                    >
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2, mb: 3 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', bgcolor: '#f8fafc', border: '1px solid #cbd5e1', borderRadius: '8px', px: 1.5, py: 0.8, width: { xs: '100%', sm: '320px' } }}>
                                <BsSearch color="#64748b" size={16} style={{ marginRight: '8px' }} />
                                <input
                                    type="text"
                                    placeholder="Search modules..."
                                    value={permSearch}
                                    onChange={(e) => setPermSearch(e.target.value)}
                                    style={{ border: 'none', background: 'transparent', width: '100%', outline: 'none', fontSize: '13px', color: '#1e293b' }}
                                />
                            </Box>
                            <Button
                                variant="outlined"
                                onClick={() => setView(1)}
                                startIcon={<BsArrowLeft />}
                                sx={{ textTransform: 'none', fontWeight: 600, borderRadius: '8px', borderColor: '#cbd5e1', color: '#475569', '&:hover': { bgcolor: '#f1f5f9', borderColor: '#94a3b8' } }}
                            >
                                Back to Roles Directory
                            </Button>
                        </Box>

                        <TableContainer component={Paper} elevation={0} sx={{ border: '1px solid #e2e8f0', borderRadius: '12px', overflow: 'hidden' }}>
                            <Table sx={{ minWidth: 650 }} size="medium">
                                <TableHead sx={{ bgcolor: '#f8fafc' }}>
                                    <TableRow>
                                        <TableCell sx={{ fontWeight: 700, color: '#0f172a', fontSize: '13px', py: 1.8 }}>System Module / Resource</TableCell>
                                        <TableCell align="center" sx={{ fontWeight: 700, color: '#0f172a', fontSize: '13px' }}>Create / Add</TableCell>
                                        <TableCell align="center" sx={{ fontWeight: 700, color: '#0f172a', fontSize: '13px' }}>Read / View</TableCell>
                                        <TableCell align="center" sx={{ fontWeight: 700, color: '#0f172a', fontSize: '13px' }}>Update / Change</TableCell>
                                        <TableCell align="center" sx={{ fontWeight: 700, color: '#0f172a', fontSize: '13px' }}>Delete / Remove</TableCell>
                                        <TableCell align="left" sx={{ fontWeight: 700, color: '#0f172a', fontSize: '13px' }}>Other / Custom</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {filteredPerms.map((option) => (
                                        <TableRow key={option.name} sx={{ '&:hover': { bgcolor: '#f8fafc' }, transition: 'background-color 0.15s' }}>
                                            <TableCell sx={{ fontWeight: 600, color: '#1e293b', fontSize: '14px', textTransform: 'capitalize' }}>
                                                {option.name.replace(/_/g, ' ')}
                                            </TableCell>

                                            {/* ADD / CREATE */}
                                            <TableCell align="center">
                                                {option.add ? (
                                                    <Chip
                                                        icon={option.add_assigned ? <BsCheckCircleFill size={14} /> : <BsDashCircleFill size={14} />}
                                                        label={option.add_assigned ? "Allowed" : "Denied"}
                                                        onClick={() => addPermission(option.role, option.add, !option.add_assigned)}
                                                        sx={{
                                                            bgcolor: option.add_assigned ? '#dcfce7' : '#fee2e2',
                                                            color: option.add_assigned ? '#166534' : '#991b1b',
                                                            fontWeight: 600,
                                                            fontSize: '12px',
                                                            cursor: 'pointer',
                                                            borderRadius: '6px',
                                                            border: '1px solid',
                                                            borderColor: option.add_assigned ? '#bbf7d0' : '#fecaca',
                                                            transition: 'all 0.2s',
                                                            '&:hover': { bgcolor: option.add_assigned ? '#bbf7d0' : '#fca5a5', transform: 'scale(1.03)' }
                                                        }}
                                                    />
                                                ) : <Typography fontSize={12} color="#cbd5e1">—</Typography>}
                                            </TableCell>

                                            {/* VIEW / READ */}
                                            <TableCell align="center">
                                                {option.view ? (
                                                    <Chip
                                                        icon={option.view_assigned ? <BsCheckCircleFill size={14} /> : <BsDashCircleFill size={14} />}
                                                        label={option.view_assigned ? "Allowed" : "Denied"}
                                                        onClick={() => addPermission(option.role, option.view, !option.view_assigned)}
                                                        sx={{
                                                            bgcolor: option.view_assigned ? '#dcfce7' : '#fee2e2',
                                                            color: option.view_assigned ? '#166534' : '#991b1b',
                                                            fontWeight: 600,
                                                            fontSize: '12px',
                                                            cursor: 'pointer',
                                                            borderRadius: '6px',
                                                            border: '1px solid',
                                                            borderColor: option.view_assigned ? '#bbf7d0' : '#fecaca',
                                                            transition: 'all 0.2s',
                                                            '&:hover': { bgcolor: option.view_assigned ? '#bbf7d0' : '#fca5a5', transform: 'scale(1.03)' }
                                                        }}
                                                    />
                                                ) : <Typography fontSize={12} color="#cbd5e1">—</Typography>}
                                            </TableCell>

                                            {/* CHANGE / UPDATE */}
                                            <TableCell align="center">
                                                {option.change ? (
                                                    <Chip
                                                        icon={option.change_assigned ? <BsCheckCircleFill size={14} /> : <BsDashCircleFill size={14} />}
                                                        label={option.change_assigned ? "Allowed" : "Denied"}
                                                        onClick={() => addPermission(option.role, option.change, !option.change_assigned)}
                                                        sx={{
                                                            bgcolor: option.change_assigned ? '#dcfce7' : '#fee2e2',
                                                            color: option.change_assigned ? '#166534' : '#991b1b',
                                                            fontWeight: 600,
                                                            fontSize: '12px',
                                                            cursor: 'pointer',
                                                            borderRadius: '6px',
                                                            border: '1px solid',
                                                            borderColor: option.change_assigned ? '#bbf7d0' : '#fecaca',
                                                            transition: 'all 0.2s',
                                                            '&:hover': { bgcolor: option.change_assigned ? '#bbf7d0' : '#fca5a5', transform: 'scale(1.03)' }
                                                        }}
                                                    />
                                                ) : <Typography fontSize={12} color="#cbd5e1">—</Typography>}
                                            </TableCell>

                                            {/* DELETE / REMOVE */}
                                            <TableCell align="center">
                                                {option.delete ? (
                                                    <Chip
                                                        icon={option.delete_assigned ? <BsCheckCircleFill size={14} /> : <BsDashCircleFill size={14} />}
                                                        label={option.delete_assigned ? "Allowed" : "Denied"}
                                                        onClick={() => addPermission(option.role, option.delete, !option.delete_assigned)}
                                                        sx={{
                                                            bgcolor: option.delete_assigned ? '#dcfce7' : '#fee2e2',
                                                            color: option.delete_assigned ? '#166534' : '#991b1b',
                                                            fontWeight: 600,
                                                            fontSize: '12px',
                                                            cursor: 'pointer',
                                                            borderRadius: '6px',
                                                            border: '1px solid',
                                                            borderColor: option.delete_assigned ? '#bbf7d0' : '#fecaca',
                                                            transition: 'all 0.2s',
                                                            '&:hover': { bgcolor: option.delete_assigned ? '#bbf7d0' : '#fca5a5', transform: 'scale(1.03)' }
                                                        }}
                                                    />
                                                ) : <Typography fontSize={12} color="#cbd5e1">—</Typography>}
                                            </TableCell>

                                            {/* OTHER / CUSTOM */}
                                            <TableCell align="left">
                                                {option.custom_perms && option.custom_perms.length > 0 ? (
                                                    <Stack direction="row" flexWrap="wrap" gap={1}>
                                                        {option.custom_perms.map((cp) => (
                                                            <Chip
                                                                key={cp.codename}
                                                                icon={cp.assigned ? <BsCheckCircleFill size={14} /> : <BsDashCircleFill size={14} />}
                                                                label={cp.name}
                                                                onClick={() => addPermission(option.role, cp.codename, !cp.assigned)}
                                                                sx={{
                                                                    bgcolor: cp.assigned ? '#dcfce7' : '#fee2e2',
                                                                    color: cp.assigned ? '#166534' : '#991b1b',
                                                                    fontWeight: 600,
                                                                    fontSize: '11px',
                                                                    cursor: 'pointer',
                                                                    borderRadius: '6px',
                                                                    border: '1px solid',
                                                                    borderColor: cp.assigned ? '#bbf7d0' : '#fecaca',
                                                                    transition: 'all 0.2s',
                                                                    '&:hover': { bgcolor: cp.assigned ? '#bbf7d0' : '#fca5a5', transform: 'scale(1.03)' }
                                                                }}
                                                            />
                                                        ))}
                                                    </Stack>
                                                ) : <Typography fontSize={12} color="#cbd5e1">—</Typography>}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                    {filteredPerms.length === 0 && (
                                        <TableRow>
                                            <TableCell colSpan={5} align="center" sx={{ py: 5, color: '#64748b', fontStyle: 'italic' }}>
                                                No system modules found matching your search.
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </FormSectionCard>
                </Box>
            ) : (
                <Box>
                    <FormHeroHeader
                        icon={<BsShieldLockFill size={26} />}
                        title="Roles & Permissions Hub"
                        subtitle="Create custom employee security roles and manage granular access rights across the platform."
                        badgeText="Access Governance"
                    />

                    <Box sx={{ mb: 3, display: 'flex', justifyContent: 'flex-end' }}>
                        <Button
                            variant="contained"
                            onClick={() => navigate('/assign-role/')}
                            startIcon={<BsPersonBadgeFill />}
                            sx={{
                                background: 'linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)',
                                borderRadius: '12px',
                                textTransform: 'none',
                                fontWeight: 700,
                                px: 3,
                                py: 1.3,
                                boxShadow: '0 4px 14px rgba(99, 102, 241, 0.25)',
                                transition: 'all 0.2s ease',
                                '&:hover': {
                                    background: 'linear-gradient(135deg, #4f46e5 0%, #4338ca 100%)',
                                    transform: 'translateY(-1px)'
                                }
                            }}
                        >
                            Assign Multiple Roles to Users →
                        </Button>
                    </Box>

                    <Grid container spacing={3.5}>
                        {/* LEFT COLUMN: ADD/EDIT ROLE FORM */}
                        <Grid size={{ xs: 12, md: 4, lg: 3.5 }}>
                            <FormSectionCard
                                icon={<BsPlusLg size={18} />}
                                title="Create Security Role"
                                subtitle="Define a unique role name to group employees with shared access tiers."
                            >
                                <form onSubmit={handleSubmit(onSubmit)}>
                                    <Box sx={{ mb: 3 }}>
                                        <RFG name="id" control={control}>
                                            <input type="hidden" />
                                        </RFG>
                                        <label className="input-label" style={labelStyle}>Role Name *</label>
                                        <div className="mb-3" style={{ marginTop: '4px' }}>
                                            <RFG name="name" control={control} rules={{ required: true }}>
                                                <input
                                                    type="text"
                                                    placeholder="e.g. Senior Tax Advisor"
                                                    style={{ width: '100%', outline: 'none' }}
                                                />
                                            </RFG>
                                        </div>
                                    </Box>
                                    <Box display="flex" gap={1.5} justifyContent="flex-end" mt={3}>
                                        <Button
                                            type="button"
                                            variant="outlined"
                                            onClick={() => reset({ name: "", id: "" })}
                                            sx={{ textTransform: 'none', fontWeight: 600, borderRadius: '8px', borderColor: '#cbd5e1', color: '#64748b' }}
                                        >
                                            Clear
                                        </Button>
                                        <Button
                                            type="submit"
                                            variant="contained"
                                            sx={{ textTransform: 'none', fontWeight: 600, borderRadius: '8px', px: 3, bgcolor: '#2563eb', '&:hover': { bgcolor: '#1d4ed8' } }}
                                        >
                                            {watch("id") ? "Update Role" : "Save Role"}
                                        </Button>
                                    </Box>
                                </form>
                            </FormSectionCard>
                        </Grid>

                        {/* RIGHT COLUMN: EXISTING ROLES DIRECTORY */}
                        <Grid size={{ xs: 12, md: 8, lg: 8.5 }}>
                            <FormSectionCard
                                icon={<BsPersonBadgeFill size={20} />}
                                title="Configured Roles Directory"
                                subtitle="Browse established roles, modify access matrices, or remove obsolete roles."
                            >
                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 3, bgcolor: '#f8fafc', border: '1px solid #cbd5e1', borderRadius: '8px', px: 1.5, py: 0.8, maxWidth: '360px' }}>
                                    <BsSearch color="#64748b" size={16} style={{ marginRight: '8px' }} />
                                    <input
                                        type="text"
                                        placeholder="Filter roles by name..."
                                        value={roleSearch}
                                        onChange={(e) => setRoleSearch(e.target.value)}
                                        style={{ border: 'none', background: 'transparent', width: '100%', outline: 'none', fontSize: '13px', color: '#1e293b' }}
                                    />
                                </Box>

                                <Stack spacing={1.5}>
                                    {filteredRoles.map((role, idx) => (
                                        <Card
                                            key={role.id || idx}
                                            elevation={0}
                                            sx={{
                                                p: 2,
                                                borderRadius: '12px',
                                                border: '1px solid',
                                                borderColor: selectedRole === role.name ? '#3b82f6' : '#e2e8f0',
                                                bgcolor: selectedRole === role.name ? '#eff6ff' : '#ffffff',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'space-between',
                                                flexWrap: { xs: 'wrap', sm: 'nowrap' },
                                                gap: 2,
                                                transition: 'all 0.2s',
                                                '&:hover': { borderColor: '#93c5fd', transform: 'translateY(-2px)', boxShadow: '0 4px 12px rgba(0,0,0,0.04)' }
                                            }}
                                        >
                                            <Box display="flex" alignItems="center" gap={2} sx={{ minWidth: 0, flex: 1, pr: 1 }}>
                                                <Box sx={{ width: 40, height: 40, borderRadius: '10px', bgcolor: '#eff6ff', color: '#2563eb', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                                    <BsKeyFill size={18} />
                                                </Box>
                                                <Box sx={{ minWidth: 0, flex: 1 }}>
                                                    <Typography fontSize={15} fontWeight={700} color="#0f172a" noWrap>
                                                        {role.name}
                                                    </Typography>
                                                    <Typography fontSize={12} color="#64748b" sx={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                                                        Access policy enabled • {Object.keys(role._permission || {}).length} modules configured
                                                    </Typography>
                                                </Box>
                                            </Box>

                                            <Box display="flex" alignItems="center" gap={1} sx={{ flexShrink: 0 }}>
                                                <Button
                                                    variant={selectedRole === role.name ? "contained" : "outlined"}
                                                    size="small"
                                                    startIcon={<BsShieldCheck />}
                                                    onClick={() => formatData(role)}
                                                    sx={{
                                                        textTransform: 'none',
                                                        fontWeight: 600,
                                                        borderRadius: '8px',
                                                        px: 2,
                                                        whiteSpace: 'nowrap',
                                                        borderColor: selectedRole === role.name ? '#2563eb' : '#cbd5e1',
                                                        bgcolor: selectedRole === role.name ? '#2563eb' : '#ffffff',
                                                        color: selectedRole === role.name ? '#ffffff' : '#334155',
                                                        '&:hover': { bgcolor: selectedRole === role.name ? '#1d4ed8' : '#f8fafc', borderColor: '#94a3b8' }
                                                    }}
                                                >
                                                    Permissions
                                                </Button>
                                                <IconButton
                                                    onClick={() => confirm2(idx, role)}
                                                    size="small"
                                                    sx={{ color: '#ef4444', bgcolor: '#fef2f2', borderRadius: '8px', p: 1, flexShrink: 0, '&:hover': { bgcolor: '#fee2e2' } }}
                                                    title="Delete Role"
                                                >
                                                    <BsTrashFill size={15} />
                                                </IconButton>
                                            </Box>
                                        </Card>
                                    ))}
                                    {filteredRoles.length === 0 && (
                                        <Box sx={{ p: 4, textAlign: 'center', bgcolor: '#f8fafc', borderRadius: '12px', border: '1px dashed #cbd5e1' }}>
                                            <Typography fontSize={14} color="#64748b" fontWeight={500}>
                                                No matching security roles found.
                                            </Typography>
                                        </Box>
                                    )}
                                </Stack>
                            </FormSectionCard>
                        </Grid>
                    </Grid>
                </Box>
            )}
        </Box>
    )
}